/* Created by Spin Design */
(function() {
  function initSmartTabsAnimation() {
    var contentBlocks = document.querySelectorAll('.smart-tabs-content-block-clone, .smart-tabs-content-wrapper .smart-tabs-content-block');
    if (!contentBlocks.length) return;

    // Set initial heights
    contentBlocks.forEach(function(block) {
      var isHidden = block.getAttribute('aria-hidden') === 'true';
      block.style.overflow = 'hidden';
      block.style.transition = 'max-height 0.35s ease, opacity 0.35s ease';

      if (isHidden) {
        block.style.maxHeight = '0px';
        block.style.opacity = '0';
      } else {
        block.style.maxHeight = block.scrollHeight + 'px';
        block.style.opacity = '1';
      }
    });

    // Observe aria-hidden changes to trigger animation
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'aria-hidden') {
          var block = mutation.target;
          var isHidden = block.getAttribute('aria-hidden') === 'true';

          if (isHidden) {
            // CLOSING: first pin the current height explicitly
            // then on next frame set to 0 so the transition has
            // two known pixel values to animate between
            block.style.maxHeight = block.scrollHeight + 'px';
            block.style.opacity = '1';

            requestAnimationFrame(function() {
              requestAnimationFrame(function() {
                block.style.transition = 'max-height 0.35s ease, opacity 0.35s ease';
                block.style.maxHeight = '0px';
                block.style.opacity = '0';
              });
            });
          } else {
            // OPENING: animate from 0 to real height
            block.style.maxHeight = block.scrollHeight + 'px';
            block.style.opacity = '1';
          }
        }
      });
    });

    contentBlocks.forEach(function(block) {
      observer.observe(block, { attributes: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmartTabsAnimation);
  } else {
    initSmartTabsAnimation();
  }

  setTimeout(initSmartTabsAnimation, 500);
})();